import {AnalysisInfo} from '@domain/rcfa'
import {ApiClient} from '@hconnect/apiclient'
import {HttpError} from '@hconnect/common/types'
import {spawnErrorToast} from '@hm/fundamental'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../localization'

import {AnalysisToCreate} from './analysisCreate.types'

export const QueryKey = 'create-analysis'

export const useCreateAnalysis = () => {
  const queryClient = useQueryClient()
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const getErrorMessage = (error: AxiosError<HttpError>) => {
    if (error?.response?.status === 403) {
      return t('errors.cannotAssignOwnerRole')
    }
    if (error.response?.data?.detail?.startsWith('The stoppage is already covered')) {
      return t('errors.analysisExistsAlready')
    }
    return 'Analysis could not be created.'
  }

  return useMutation({
    mutationFn: async (analysisData: AnalysisToCreate) => {
      const path = '/rootcausefailureanalysis/analyses'

      return (await ApiClient.axiosInstance.post<AnalysisInfo>(path, analysisData)).data
    },
    onSuccess: async (data: AnalysisInfo) => {
      queryClient.removeQueries({queryKey: ['analysis-list']})
      await queryClient.invalidateQueries({queryKey: ['analysis-list']})
      await queryClient.invalidateQueries({queryKey: ['analysis-list-counts']})
      queryClient.removeQueries({queryKey: ['analysis-list-counts']})
      queryClient.removeQueries({queryKey: ['stoppages']})
      return data
    },
    onError: (error: AxiosError<HttpError>) => {
      if (error?.response?.status && error.response.status >= 400) {
        spawnErrorToast(getErrorMessage(error), {closeOnClick: true})
      }
    }
  })
}
